import { starList } from "@/mocks/celebrityData";

export default function Stars() {
  return (
    <section id="stars" className="bg-ink-950 py-16 text-white" aria-label="明星人物">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-gold-500">
              <i className="ri-star-smile-line" aria-hidden="true"></i> 星光档案
            </span>
            <h2 className="mt-2 font-serif text-3xl font-black md:text-4xl">近期备受关注的明星</h2>
            <p className="mt-2 max-w-xl text-sm text-white/70">
              基于公开作品与近期动态整理的人物卡片，汇集代表作与形象定位，供你快速建立印象。
            </p>
          </div>
        </div>

        <div className="mt-9 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {starList.map((s) => (
            <article
              key={s.name}
              className="group overflow-hidden rounded-2xl border border-white/10 bg-white/5 transition hover:border-gold-500/50"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={s.avatar}
                  alt={`明星人物 ${s.name}`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-3">
                  <span className="text-xs font-medium text-gold-500">{s.field}</span>
                  <p className="font-serif text-lg font-black text-white">{s.name}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3">
          {starList.slice(0, 3).map((s) => (
            <div
              key={s.name}
              className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur"
            >
              <div className="flex items-center justify-between">
                <p className="font-serif text-lg font-black text-white">
                  {s.name}
                  <span className="ml-2 text-xs font-normal text-white/50">{s.tagline}</span>
                </p>
                <i className="ri-quote-text text-2xl text-gold-500/60" aria-hidden="true"></i>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-white/75">{s.intro}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {s.works.slice(0, 2).map((w) => (
                  <span
                    key={w}
                    className="rounded-full border border-white/15 px-3 py-1 text-[11px] text-white/70"
                  >
                    {w}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}